import HttpRequestRotoBrain from "../../Services/HttpRequestRotoBrain";


export const getLeague = async (provider:string,body:any) => {

  try {
    const response = await HttpRequestRotoBrain({
      method: "POST",
      url: `/v1/leagues/${provider}`,
      data: body
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};

export const getSlepperUserInfo = async (userName:string) => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "GET",
      url: `/v1/leagues/SLEEPER/${userName}/info`,
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};

export const leagueSync = async (provider:string, league_id:string, body:any) => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "POST",
      url: `/v1/leagues/${provider}/${league_id}/sync`,
      data: body
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};


export const getLeagueSyncStatus= async (provider:string, league_id:string) => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "GET",
      url: `/v1/leagues/${provider}/${league_id}/sync/status`,
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};


export const getLeagueInfo= async () => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "GET",
      url: `/v1/leagues/info`,
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};